// extracted by mini-css-extract-plugin
module.exports = {"warrantyReturns__page-container":"WarrantyReturnsPageContainer_warrantyReturns__page-container__gBH2v"};